<template>
  <LayoutAdmin :active-periode="activePeriodic">
    <section class="w-full px-4 mt-6 md:px-8">
      <div class="flex items-center">
        <h1 class="text-lg md:text-2xl">Dashboard</h1>
        <ChoiseCompany v-if="!loading.company && options.length"
          @selected:company="dataCompany = $event" :options="options" :dataCompany="dataCompany" />
      </div>
      <section class="relative grid flex-wrap my-8 lg:grid-cols-4 md:grid-cols-2 sm:grid-cols-2 lg:gap-8 md:gap-4">
        <section class="flex items-center w-full p-4 mb-3 rounded-md shadow-md card-detail-company md:mb-0 md:p-8">
          <div class="flex items-center justify-center w-12 h-12 text-white bg-blue-500 rounded-md bg-icon">
            <font-awesome-icon icon="fa-user" class="text-lg" />
          </div>
          <div class="ml-3">
            <p class="text-sm">{{ data?.total_employment }}</p>
            <p class="text-xs text-gray-400">Total employees</p>
          </div>
        </section>
        <section class="flex items-center w-full p-4 mb-3 rounded-md shadow-md card-detail-company md:mb-0 md:p-8">
          <div class="flex items-center justify-center w-12 h-12 text-white bg-blue-500 rounded-md bg-icon">
            <font-awesome-icon icon="fa-home-alt" class="text-lg" />
          </div>
          <div class="ml-3">
            <p class="text-sm">{{ data?.total_departement }}</p>
            <p class="text-xs text-gray-400">Total departement</p>
          </div>
        </section>
        <section class="flex items-center w-full p-4 mb-3 rounded-md shadow-md card-detail-company md:mb-0 md:p-8">
          <div class="flex items-center justify-center w-12 h-12 text-white bg-blue-500 rounded-md bg-icon">
            <font-awesome-icon icon="fa-pen-to-square" class="text-lg" />
          </div>
          <div class="ml-3">
            <p class="text-sm">
              {{ data?.total_leave }}
            </p>
            <p class="text-xs text-gray-400">Total leave request</p>
          </div>
        </section>
        <section class="flex items-center w-full p-4 mb-3 rounded-md shadow-md card-detail-company md:mb-0 md:p-8">
          <div class="flex items-center justify-center w-12 h-12 text-white bg-blue-500 rounded-md bg-icon">
            <font-awesome-icon icon="fa-user-xmark" class="text-lg" />
          </div>
          <div class="ml-3">
            <p class="text-sm">0</p>
            <p class="text-xs text-gray-400">On leave today</p>
          </div>
        </section>
        <Loading v-if="loading.getData" />
      </section>

      <section class="grid-cols-4 gap-6 mb-6 md:grid">
        <section class="relative col-span-3 mb-10">
          <AttendanceLeaveStatistic :attendance-leave-statistics="attendanceLeaveStatistic.datas"
            :meta="attendanceLeaveStatistic.meta" :page="page" :limit="limit" :selected-filter="selectedFilter"
            :is-loading="loading.getStatistic" @on-selected-filter="onSelectedFilter" @on-pagination="onPagination" />
          <NeedApproval v-if="needApprovals.length" ref="needApproval" :need-approvals="needApprovals"
            @on-edit-status="onEditStatus" @on-approval-employee="onApprovalEmployee" />
          <EmployementStatistic :total_employment_status="data.total_employment_status"
            :departement_statistic="data.departement_statistic" :designation_statistic="data.designation_statistic" />
          <Loading v-if="loading.getData" />
        </section>
        <section class="relative col-span-1">
          <OnBreakMonitor :emp-on-break="attendances" :is-loading="loading.getAttendance" />
          <AttedanceStatistic />
          <Loading v-if="loading.getData" />
        </section>
      </section>
    </section>
  </LayoutAdmin>
</template>

<script>
import EmployementStatistic from "@/components/EmployementStatistic.vue";
import AttedanceStatistic from "@/components/AttendanceStatistic.vue";
import OnBreakMonitor from "@/components/OnBreakMonitor.vue";
import LayoutAdmin from "../components/Layout/Admin.vue";
import NeedApproval from "@/components/Home/NeedApproval.vue";
import AttendanceLeaveStatistic from "@/components/Home/AttendanceLeaveStatistic.vue";
import decryptToken from "@/utils/decryptToken";
import { GetAllCompanyEmployeeOptionsAPI, GetDahsboardAPI } from "@/actions/company";
import { GetNeedApprovalAPI } from "@/actions/need-approval";
import { getAttendanceLeaveStatistic } from "@/actions/statistic";
import { EditStatusLeaveRequestAPI } from "@/actions/leave-request";
import { EditOvertimeRequestAPI } from "@/actions/overtime-request";
import { EditOvertimeRequestAPI as EditOutsideRequestAPI } from "@/actions/outside-request";
import { EditOffdayRequestAPI } from "@/actions/offday";
import { EditChangeWorkshiftAPI } from "@/actions/change-shift";
import { GetPeriodicActiveAPI } from "@/actions/periodic";
import { GetAttendanceAPI } from "@/actions/attendance";
import ChoiseCompany from "@/components/ChoiseCompany.vue";
import Loading from "@/components/Loading.vue";
import { useToast } from "vue-toastification";
import moment from 'moment';

export default {
  name: "DashboardPage",
  data() {
    return {
      activePeriodic: "-",
      showSelectCompany: false,
      superAdmin: false,
      options: [],
      dataCompany: {},
      loadingData: true,
      loading: {
        company: true,
        getData: true,
        getStatistic: false,
        getAttendance: true,
      },
      data: {
        total_employment: 0,
        total_departement: 0,
        total_leave: 0,
        total_employment_status: [],
        departement_statistic: [],
      },
      needApprovals: [],
      attendances: [],
      attendanceLeaveStatistic: { datas: [], meta: {} },
      selectedFilter: "by_late",
      page: 1,
      limit: 5,
      accountData: null,
    };
  },
  components: {
    LayoutAdmin,
    Loading,
    EmployementStatistic,
    AttedanceStatistic,
    OnBreakMonitor,
    ChoiseCompany,
    NeedApproval,
    AttendanceLeaveStatistic,
  },
  setup() {
    const toast = useToast();
    return { toast };
  },
  methods: {
    async getNeedApproval() {
      const companyId = this.dataCompany?._id;
      const response = await GetNeedApprovalAPI({
        companyId,
      });
      if (response?.status === 401) {
        this.$router.push("/login");
        this.$store.commit("changeIsLoggedIn", false);
      }
      if (response?.status === 200) {
        this.needApprovals = response.data;
      }
    },
    async getAllCompany() {
      const response = await GetAllCompanyEmployeeOptionsAPI();
      this.options = response?.data;
      this.dataCompany = this.options[0];
      this.loading.company = false;
    },
    async handleGetDashboard() {
      this.loading.getData = true;
      const querySuperAdmin = `?company=${this.dataCompany?._id}`;
      const response = await GetDahsboardAPI(querySuperAdmin);
      const data = response?.data;
      if (response?.status === 401) {
        this.$router.push("/login");
        this.toast.error(response?.data?.message);
        this.$store.commit("changeIsLoggedIn", false);
      } else if (response?.status === 200) {
        this.data.total_departement = data?.total_departement;
        this.data.total_employment = data?.total_employment;
        this.data.total_leave = data?.total_leave;
        this.data.total_employment_status = data?.employment_status;
        this.data.departement_statistic = data?.departement_statistic;
        this.data.designation_statistic = data?.designation_statistic;
        this.loading.getData = false;
      }
    },
    async getAttendanceLeaveStatistic() {
      this.loading.getStatistic = true;
      const page = this.page || 1;
      const limit = this.limit || 5;
      const selectedFilter = this.selectedFilter;
      const { success, data, meta, code, message } =
        await getAttendanceLeaveStatistic({
          companyId: this.dataCompany?._id,
          page,
          limit,
          selectedFilter,
        });

      if (success) {
        this.attendanceLeaveStatistic = {
          datas: data,
          meta,
        };

        this.loading.getStatistic = false;
      } else {
        if (code === 401) {
          return this.$router.push("/login");
        } else {
          this.toast.error(message);
        }
      }
    },
    onSelectedFilter(value) {
      this.selectedFilter = value;
      this.page = 1;
      this.getAttendanceLeaveStatistic();
    },
    onPagination(value) {
      this.page = value;
      this.getAttendanceLeaveStatistic();
    },
    async onEditStatus(value) {
      this.loading.getData = true;
      const payload = {
        empleave_status: value.empleave_status,
      };
      const response = await EditStatusLeaveRequestAPI(value.id, payload);
      if (response?.status === 401) {
        this.$router.push("/login");
        this.$store.commit("changeIsLoggedIn", false);
      }
      if (response.status === 200) {
        this.$refs.needApproval.closeModal();
        this.getNeedApproval();
      }
      this.showMessageStatus(response);
      this.loading.getData = false;
    },
    showMessageStatus(response) {
      if (response.status === 200) {
        this.toast.success(response?.data?.message);
      } else {
        if (response.data.message) {
          this.toast.error(response?.data?.message);
        }
      }
    },
    async onApprovalEmployee({ id, payload, type }) {
      if (type === "Overtime Request") {
        await this.handleApprovalOvertimeRequest({ id, payload });
      } else if (type === "Outside Assignment") {
        await this.handleApprovalOutsideRequest({ id, payload });
      } else if (type === "Change Offday") {
        await this.handleApprovalOffdayRequest({ id, payload });
      } else if (type === "Change Workshift") {
        await this.handleApprovalWorkshiftRequest({ id, payload });
      }
    },
    async handleApprovalOvertimeRequest({ id, payload }) {
      this.loading.getData = true;
      const response = await EditOvertimeRequestAPI(id, payload);
      if (response?.status === 401) {
        this.$router.push("/login");
        this.$store.commit("changeIsLoggedIn", false);
      }
      if (response.status === 200) {
        this.$refs.needApproval.closeModal();
        this.getNeedApproval();
      }
      this.showMessageStatus(response);
      this.loading.getData = false;
    },
    async handleApprovalOutsideRequest({ id, payload }) {
      this.loading.getData = true;
      const response = await EditOutsideRequestAPI(id, payload);
      if (response?.status === 401) {
        this.$router.push("/login");
        this.$store.commit("changeIsLoggedIn", false);
      }
      if (response.status === 200) {
        this.$refs.needApproval.closeModal();
        this.getNeedApproval();
      }
      this.showMessageStatus(response);
      this.loading.getData = false;
    },
    async handleApprovalOffdayRequest({ id, payload }) {
      this.loading.getData = true;
      const response = await EditOffdayRequestAPI(id, payload);
      if (response?.status === 401) {
        this.$router.push("/login");
        this.$store.commit("changeIsLoggedIn", false);
      }
      if (response.status === 200) {
        this.$refs.needApproval.closeModal();
        this.getNeedApproval();
      }
      this.showMessageStatus(response);
      this.loading.getData = false;
    },
    async handleApprovalWorkshiftRequest({ id, payload }) {
      this.loading.getData = true;
      const response = await EditChangeWorkshiftAPI(id, payload);
      if (response?.status === 401) {
        this.$router.push("/login");
        this.$store.commit("changeIsLoggedIn", false);
      }
      if (response.status === 200) {
        this.$refs.needApproval.closeModal();
        this.getNeedApproval();
      }
      this.showMessageStatus(response);
      this.loading.getData = false;
    },
    getAccountData() {
      const accountData = JSON.parse(localStorage.getItem("accountData"));
      this.accountData = accountData;
    },
    async handleGetPeriodicActive() {
      const querySuperAdmin = `?company_id=${this?.dataCompany?._id}`;
      const response = await GetPeriodicActiveAPI(querySuperAdmin);
      if (response?.status === 401) {
        this.$router.push("/login");
        this.$store.commit("changeIsLoggedIn", false);
      }
      console.log(response?.data);
      this.activePeriodic = response?.data?.periodic_month + " (" + response?.data?.periodic_start_date + " to " + response?.data?.periodic_end_date + ")";
    },
    dateToday() {
      const dateObject = new Date();
      const month = (dateObject.getMonth() + 1).toString().padStart(2, "0");
      const day = dateObject.getDate().toString().padStart(2, "0");
      const year = dateObject.getFullYear();
      return `${year}-${month}-${day}`;
    },
    changeFormatDateToInputFormat(date) {
      if (date) {
        const oldDate = date.split("/");
        const newDate = `${oldDate[2]}-${oldDate[0]}-${oldDate[1]}`;
        return newDate;
      }
      return "-";
    },
    async handleGetAttendance() {
      this.loading.getAttendance = true;
      const companyId = this.dataCompany?._id;
      const requestDate = moment().format('YYYY-MM-DD');
      const periodicId = null;
      const response = await GetAttendanceAPI({
        companyId,
        requestDate,
        periodicId,
      });
      if (response?.status === 401) {
        this.$router.push("/login");
        this.$store.commit("changeIsLoggedIn", false);
      }
      if (response?.status === 200) {
        const filterAttedanceToday = response.data.filter(
          (attedance) => attedance?.break_out !== "-" && attedance?.break_in === "-"
        );
        this.attendances = filterAttedanceToday.map((attendance) => ({
          ...attendance,
          attendance_date: this.changeFormatDateToInputFormat(
            attendance?.attendance_date
          ),
          attendance_date_out: this.changeFormatDateToInputFormat(
            attendance?.attendance_date_out
          ),
        }));
        console.log(this.attendances);
        // this.all_attendance = response.data.map((attendance) => ({
        //   ...attendance,
        //   attendance_date: this.changeFormatDateToInputFormat(
        //     attendance?.attendance_date
        //   ),
        //   attendance_date_out: this.changeFormatDateToInputFormat(
        //     attendance?.attendance_date_out
        //   ),
        // }));
        // this.handleFilter(
        //   (this.filter.date = this.filter.date
        //     ? this.filter.date
        //     : this.dateToday()),
        //   this.filter.departement,
        //   this.filter.workshift,
        //   this.filter.behavior,
        //   this.filter.status,
        //   this.filter.employment
        // );
      }
      this.loading.getAttendance = false;
    },
  },
  watch: {
    dataCompany: {
      handler: function () {
        this.page = 1;
        this.handleGetDashboard();
        this.getNeedApproval();
        this.getAttendanceLeaveStatistic();
        this.handleGetPeriodicActive();
        this.handleGetAttendance();
      },
      deep: true,
    },
  },
  mounted() {
    const payload = decryptToken();
    this.superAdmin =
      payload?.role === "Super Admin" ||
      payload?.role === "Group Admin" ||
      !payload?.company_group;
    this.getAllCompany();
  },
};
</script>

<style scoped>
.card-detail-company {
  background: white;
}
</style>
